import { AppError } from '@/errors/appError';
import { globals } from '@/globals';

export function useStoreByCurrentRoute<T = any>() {
    const storeFn = globals.router.currentRoute.value.meta.store as (() => T) | undefined;

    if (!storeFn) {
        throw new AppError(`No store found in route meta for ${String(globals.router.currentRoute.value.name)}`);
    }

    return storeFn();
}

export function isStoreExistByCurrentRoute() {
    return !!globals.router.currentRoute.value.meta.store;
}
